import { useMutation, useQueryClient } from '@tanstack/react-query';

import { notificationKeys, type NotificationPages } from '@entities/notification';
import { api, notificationEndpoints } from '@shared/api';

/**
 * 알림 읽음. 캐시를 먼저 바꿔(낙관적) 목록 · 빨간 점이 바로 바뀐다. 실패하면 되돌린다.
 * 실패 토스트는 띄우지 않는다(읽음은 다음 조회에서 맞춰진다).
 */
export function useReadNotificationMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: number) =>
      api.request(notificationEndpoints.readNotification, { params: { id } }),
    meta: { silent: true },
    onMutate: async (id) => {
      await queryClient.cancelQueries({ queryKey: notificationKeys.lists() });
      const previous = queryClient.getQueryData<NotificationPages>(notificationKeys.lists());
      queryClient.setQueryData<NotificationPages>(notificationKeys.lists(), (data) =>
        data
          ? {
              ...data,
              pages: data.pages.map((page) => ({
                ...page,
                items: page.items.map((item) =>
                  item.id === id ? { ...item, isRead: true } : item,
                ),
              })),
            }
          : data,
      );
      return { previous };
    },
    onError: (_error, _idx, context) => {
      if (context?.previous) queryClient.setQueryData(notificationKeys.lists(), context.previous);
    },
  });
}
